// Texte für das Produkt "Hotel-Reservierung für das Visa-Dossier".
// Werden in LanguageContext in die bestehenden en/fr-Übersetzungen gemischt.

const hotelTranslations = {
  en: {
    chat_welcome: "Welcome to VisaAlerts! 👋 How can I help you today? You can pay by card via Stripe, or from Tunisia via DHMAD.tn (TND) — pick a topic below or type your question. New: we also offer a hotel reservation for your visa file (€15 / 20 TND).",
    chat_topic_hotel: '🏨 Hotel reservation for visa',
    chat_topic_hotel_delivery: '📄 When do I get my hotel PDF?',
    chat_topic_hotel_real: '✅ Is the hotel reservation real?',
    chat_answer_hotel: "We offer a hotel reservation for your visa file (proof of accommodation for TLS, VFS and BLS) for €15, or 20 TND from Tunisia via DHMAD.tn. It's a one-time payment, no subscription. How to order: log in, open your dashboard, go to 'Hotel reservation for your visa file', enter the travellers (as in the passport), city, dates and your appointment date, then pay by card or DHMAD. You receive a confirmation email right away.",
    chat_answer_hotel_delivery: "Once your payment is confirmed (instantly by card, within 24h with DHMAD), we book your hotel and upload the PDF confirmation to your dashboard – in time before your visa appointment. You get an email as soon as it's ready, and you can download the PDF under 'My hotel reservations'.",
    chat_answer_hotel_real: "Yes – it's a real reservation in your name, verifiable with the hotel, not a fake document. It comes with free cancellation and no payment to the hotel. After your appointment we cancel it free of charge before the deadline – or tell us if you want to keep it. Note: a hotel reservation does not guarantee visa approval.",
    hotel_buy_stripe: 'Buy with Stripe (€15)',
    hotel_ribbon: 'NEW SERVICE',
    hotel_tagline: 'Proof of accommodation for TLS, VFS & BLS',
    hotel_price_note: 'Per reservation • No subscription',
    hero_hotel_badge: 'NEW: Hotel reservation for visa',
    hero_hotel_title: 'Appointment found? Your hotel proof too.',
    hero_hotel_text: 'Real hotel reservation in your name with free cancellation – ready as PDF for your visa file.',
    hero_hotel_btn: 'Hotel reservation',
    hero_hotel_notif_title: 'Hotel reservation ready',
    hero_hotel_notif_desc: 'Paris • Free cancellation • PDF',
    hotel_promo_badge: 'New: Hotel reservation for visa',
    hotel_promo_title: 'Got your appointment? Complete your visa file with a hotel reservation.',
    hotel_promo_text: 'Consulates and visa centres (TLS, VFS, BLS) ask for proof of accommodation. We make a real hotel reservation in your name – with free cancellation, so you never pay for a hotel before your visa is approved.',
    hotel_promo_problem: 'Paying for a hotel before your visa is approved is risky – and fake reservations can lead to a refusal. Our reservations are real and verifiable.',
    hotel_promo_benefit_1: 'Real reservation, verifiable with the hotel',
    hotel_promo_benefit_2: 'No hotel payment – free cancellation',
    hotel_promo_benefit_3: 'PDF confirmation in your dashboard, in time for your appointment',
    hotel_promo_benefit_4: 'Pay by card (€15) or from Tunisia with DHMAD (20 TND)',
    hotel_promo_cta: 'Order now',
    hotel_mock_confirmed: 'Reservation confirmed',
    hotel_mock_guests: 'Guests',
    hotel_mock_free_cancel: 'Free cancellation – no prepayment',
    hotel_mock_verifiable: 'Booking number verifiable with the hotel',
    hotel_mock_ready: 'Ready for your visa file',
    hotel_steps_title: 'How it works',
    hotel_step_1_title: 'Order & pay',
    hotel_step_1_desc: 'Enter travellers, city, dates and your appointment date in your dashboard. Pay by card or DHMAD.',
    hotel_step_2_title: 'We book a real hotel',
    hotel_step_2_desc: 'We reserve a suitable hotel in your name with free cancellation – no payment to the hotel.',
    hotel_step_3_title: 'Download your PDF',
    hotel_step_3_desc: 'Your confirmation is ready in your dashboard before your appointment. Afterwards we cancel it free of charge – or you keep it.',
    hotel_promo_disclaimer: 'VisaGo is an independent service and not affiliated with any embassy, TLS, VFS or BLS. A hotel reservation does not guarantee visa approval.',
    pricing_subtitle: 'Alerts to catch your appointment – and a hotel reservation to complete your visa file.',
    hotel_badge: 'NEW',
    hotel_title: 'Hotel Reservation for Visa',
    hotel_subtitle: 'Real reservation • Free cancellation',
    hotel_price: '15',
    hotel_price_tnd: '20',
    hotel_period: 'one-time',
    hotel_feature_1: 'Real, verifiable reservation in your name',
    hotel_feature_2: 'Free cancellation – no hotel payment needed',
    hotel_feature_3: 'PDF confirmation ready for TLS, VFS & BLS',
    hotel_feature_4: 'Delivered in time for your visa appointment',
    hotel_feature_5: 'Up to 6 travellers per reservation',
    hotel_cta: 'Order hotel reservation',
    hotel_pay_card: 'Pay by card',
    hotel_pay_dhmad: 'Pay with DHMAD',
    hotel_note: 'We book a real hotel with free cancellation and cancel it for you after your appointment – unless you want to keep it.',

    hotel_section_title: 'Hotel reservation for your visa file',
    hotel_section_desc: 'Order a real, cancellable hotel reservation as proof of accommodation. You receive the PDF confirmation here in your dashboard.',
    hotel_new_order: 'New order',
    hotel_travelers: 'Travellers (as in passport)',
    hotel_first_name: 'First name',
    hotel_last_name: 'Last name',
    hotel_add_traveler: 'Add traveller',
    hotel_remove: 'Remove',
    hotel_country: 'Destination country',
    hotel_city: 'City',
    hotel_check_in: 'Check-in',
    hotel_check_out: 'Check-out',
    hotel_appointment: 'Visa appointment date',
    hotel_whatsapp: 'WhatsApp (optional)',
    hotel_notes: 'Notes (optional)',
    hotel_notes_placeholder: 'e.g. preferred area, 2 rooms…',
    hotel_consent: 'I agree that my travellers\' names are used to make the reservation. They are deleted once the order is closed.',
    hotel_my_orders: 'My hotel reservations',
    hotel_no_orders: 'No hotel reservations yet.',
    hotel_download_pdf: 'Download PDF',
    hotel_pay_now_dhmad: 'Pay now with DHMAD',
    hotel_deadline: 'Free cancellation until',
    hotel_reference: 'Booking no.',
    hotel_error_fill: 'Please fill in all required fields.',
    hotel_error_dates: 'Check-out must be after check-in.',
    hotel_error_consent: 'Please accept the consent checkbox.',
    hotel_error_create: 'Could not create the order. Please try again.',
    hotel_dhmad_created: 'Order saved – redirecting you to DHMAD…',
    hotel_paid_success: 'Payment received! We are now booking your hotel.',
    hotel_payment_pending: 'Payment not completed yet.',
    hotel_status_awaiting_payment: 'Awaiting payment',
    hotel_status_paid: 'Paid – being booked',
    hotel_status_booked: 'Booked – PDF coming',
    hotel_status_delivered: 'Ready',
    hotel_status_cancelled: 'Cancelled (closed)',
    hotel_status_completed: 'Completed',
    hotel_status_refused: 'Refused',
  },
  fr: {
    chat_welcome: "Bienvenue chez VisaAlerts ! 👋 Comment puis-je vous aider ? Vous pouvez payer par carte via Stripe, ou depuis la Tunisie via DHMAD.tn (TND) — choisissez un sujet ci-dessous ou tapez votre question. Nouveau : nous proposons aussi une réservation d'hôtel pour votre dossier visa (15 € / 20 TND).",
    chat_topic_hotel: "🏨 Réservation d'hôtel pour visa",
    chat_topic_hotel_delivery: "📄 Quand vais-je recevoir le PDF de l'hôtel ?",
    chat_topic_hotel_real: "✅ La réservation d'hôtel est-elle vraie ?",
    chat_answer_hotel: "Nous proposons une réservation d'hôtel pour votre dossier visa (justificatif d'hébergement pour TLS, VFS et BLS) à 15 €, ou 20 TND depuis la Tunisie via DHMAD.tn. Paiement unique, sans abonnement. Pour commander : connectez-vous, ouvrez votre tableau de bord, section « Réservation d'hôtel pour votre dossier visa », indiquez les voyageurs (comme sur le passeport), la ville, les dates et la date de votre rendez-vous, puis payez par carte ou DHMAD. Vous recevez aussitôt un email de confirmation.",
    chat_answer_hotel_delivery: "Dès que votre paiement est confirmé (immédiatement par carte, sous 24h avec DHMAD), nous réservons votre hôtel et déposons la confirmation PDF dans votre tableau de bord – à temps avant votre rendez-vous visa. Vous recevez un email dès qu'elle est prête et pouvez télécharger le PDF dans « Mes réservations d'hôtel ».",
    chat_answer_hotel_real: "Oui – c'est une vraie réservation à votre nom, vérifiable auprès de l'hôtel, pas un faux document. Elle est avec annulation gratuite et sans paiement à l'hôtel. Après votre rendez-vous, nous l'annulons gratuitement avant la date limite – ou dites-nous si vous voulez la garder. Attention : une réservation d'hôtel ne garantit pas l'obtention du visa.",
    hotel_buy_stripe: 'Payer avec Stripe (15 €)',
    hotel_ribbon: 'NOUVEAU SERVICE',
    hotel_tagline: "Justificatif d'hébergement pour TLS, VFS et BLS",
    hotel_price_note: 'Par réservation • Sans abonnement',
    hero_hotel_badge: "NOUVEAU : Réservation d'hôtel pour visa",
    hero_hotel_title: "Rendez-vous trouvé ? Votre justificatif d'hôtel aussi.",
    hero_hotel_text: "Vraie réservation d'hôtel à votre nom avec annulation gratuite – prête en PDF pour votre dossier visa.",
    hero_hotel_btn: "Réservation d'hôtel",
    hero_hotel_notif_title: "Réservation d'hôtel prête",
    hero_hotel_notif_desc: 'Paris • Annulation gratuite • PDF',
    hotel_promo_badge: "Nouveau : réservation d'hôtel pour visa",
    hotel_promo_title: "Rendez-vous obtenu ? Complétez votre dossier visa avec une réservation d'hôtel.",
    hotel_promo_text: "Les consulats et centres de visa (TLS, VFS, BLS) demandent un justificatif d'hébergement. Nous faisons une vraie réservation d'hôtel à votre nom – avec annulation gratuite, pour ne jamais payer un hôtel avant l'obtention du visa.",
    hotel_promo_problem: "Payer un hôtel avant d'avoir le visa est risqué – et une fausse réservation peut entraîner un refus. Nos réservations sont vraies et vérifiables.",
    hotel_promo_benefit_1: "Vraie réservation, vérifiable auprès de l'hôtel",
    hotel_promo_benefit_2: "Aucun paiement à l'hôtel – annulation gratuite",
    hotel_promo_benefit_3: 'Confirmation PDF dans votre tableau de bord, à temps pour votre rendez-vous',
    hotel_promo_benefit_4: 'Paiement par carte (15 €) ou depuis la Tunisie avec DHMAD (20 TND)',
    hotel_promo_cta: 'Commander',
    hotel_mock_confirmed: 'Réservation confirmée',
    hotel_mock_guests: 'Voyageurs',
    hotel_mock_free_cancel: 'Annulation gratuite – sans prépaiement',
    hotel_mock_verifiable: "Numéro de réservation vérifiable auprès de l'hôtel",
    hotel_mock_ready: 'Prête pour votre dossier visa',
    hotel_steps_title: 'Comment ça marche',
    hotel_step_1_title: 'Commandez et payez',
    hotel_step_1_desc: 'Indiquez voyageurs, ville, dates et la date de votre rendez-vous dans votre tableau de bord. Payez par carte ou DHMAD.',
    hotel_step_2_title: 'Nous réservons un vrai hôtel',
    hotel_step_2_desc: "Nous réservons un hôtel adapté à votre nom, avec annulation gratuite – aucun paiement à l'hôtel.",
    hotel_step_3_title: 'Téléchargez votre PDF',
    hotel_step_3_desc: "Votre confirmation est prête dans votre tableau de bord avant le rendez-vous. Ensuite, nous l'annulons gratuitement – ou vous la gardez.",
    hotel_promo_disclaimer: "VisaGo est un service indépendant, sans lien avec les ambassades, TLS, VFS ou BLS. Une réservation d'hôtel ne garantit pas l'obtention du visa.",
    pricing_subtitle: 'Des alertes pour décrocher votre rendez-vous – et une réservation d\'hôtel pour compléter votre dossier visa.',
    hotel_badge: 'NOUVEAU',
    hotel_title: "Réservation d'hôtel pour visa",
    hotel_subtitle: 'Vraie réservation • Annulation gratuite',
    hotel_price: '15',
    hotel_price_tnd: '20',
    hotel_period: 'paiement unique',
    hotel_feature_1: 'Vraie réservation vérifiable à votre nom',
    hotel_feature_2: "Annulation gratuite – aucun paiement à l'hôtel",
    hotel_feature_3: 'Confirmation PDF prête pour TLS, VFS et BLS',
    hotel_feature_4: 'Livrée à temps pour votre rendez-vous visa',
    hotel_feature_5: "Jusqu'à 6 voyageurs par réservation",
    hotel_cta: "Commander la réservation d'hôtel",
    hotel_pay_card: 'Payer par carte',
    hotel_pay_dhmad: 'Payer avec DHMAD',
    hotel_note: "Nous réservons un vrai hôtel avec annulation gratuite et l'annulons pour vous après votre rendez-vous – sauf si vous souhaitez le garder.",

    hotel_section_title: "Réservation d'hôtel pour votre dossier visa",
    hotel_section_desc: "Commandez une vraie réservation d'hôtel annulable comme justificatif d'hébergement. Vous recevez la confirmation PDF ici, dans votre tableau de bord.",
    hotel_new_order: 'Nouvelle commande',
    hotel_travelers: 'Voyageurs (comme sur le passeport)',
    hotel_first_name: 'Prénom',
    hotel_last_name: 'Nom',
    hotel_add_traveler: 'Ajouter un voyageur',
    hotel_remove: 'Supprimer',
    hotel_country: 'Pays de destination',
    hotel_city: 'Ville',
    hotel_check_in: 'Arrivée',
    hotel_check_out: 'Départ',
    hotel_appointment: 'Date du rendez-vous visa',
    hotel_whatsapp: 'WhatsApp (facultatif)',
    hotel_notes: 'Remarques (facultatif)',
    hotel_notes_placeholder: 'ex. quartier souhaité, 2 chambres…',
    hotel_consent: 'J\'accepte que les noms des voyageurs soient utilisés pour la réservation. Ils sont supprimés une fois la commande clôturée.',
    hotel_my_orders: "Mes réservations d'hôtel",
    hotel_no_orders: "Aucune réservation d'hôtel pour le moment.",
    hotel_download_pdf: 'Télécharger le PDF',
    hotel_pay_now_dhmad: 'Payer maintenant avec DHMAD',
    hotel_deadline: "Annulation gratuite jusqu'au",
    hotel_reference: 'N° de réservation',
    hotel_error_fill: 'Veuillez remplir tous les champs obligatoires.',
    hotel_error_dates: "La date de départ doit être après la date d'arrivée.",
    hotel_error_consent: 'Veuillez cocher la case de consentement.',
    hotel_error_create: 'Impossible de créer la commande. Veuillez réessayer.',
    hotel_dhmad_created: 'Commande enregistrée – redirection vers DHMAD…',
    hotel_paid_success: 'Paiement reçu ! Nous réservons maintenant votre hôtel.',
    hotel_payment_pending: "Le paiement n'est pas encore finalisé.",
    hotel_status_awaiting_payment: 'En attente de paiement',
    hotel_status_paid: 'Payée – réservation en cours',
    hotel_status_booked: 'Réservée – PDF en préparation',
    hotel_status_delivered: 'Prête',
    hotel_status_cancelled: 'Annulée (clôturée)',
    hotel_status_completed: 'Terminée',
    hotel_status_refused: 'Refusée',
  },
};

export default hotelTranslations;
